import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  IconButton
} from '@mui/material';
import InputField from 'src/components/InputField';
import LoadingButtonWrapper from 'src/components/LoadingButtonWrapper';
import CloseIcon from '@mui/icons-material/Close';
import { api } from 'src/Api';
import { toast } from 'react-toastify';

export default function JobGroupEditAdd({
  open,
  mode, // 'add' | 'edit'
  initialValue,
  onSave,
  onClose,
  onDelete,
  saveLoading
}) {
  const [title, setTitle] = useState(initialValue?.name || '');

  useEffect(() => {
    setTitle(initialValue?.name || '');
  }, [initialValue, open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
        <DialogTitle sx={{ flex: 1 }}>
          {mode === 'add' ? 'Add Job Group' : 'Edit Job Group'}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
            mt: 1,
            mr: 1
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent>
        <InputField
          label="Title"
          backgroundColor="#fff"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
      </DialogContent>
      <DialogActions sx={{ pb: 2, pr: 3, pt: 0 }}>
        {mode == 'edit' && (
          <LoadingButtonWrapper
            variant="outlined"
            title="Delete"
            style={{
              width: 60,
              borderRadius: 5,
              letterSpacing: 0.5,
              boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
              transition: 'width 0.3s ease'
            }}
            height={30}
            fontSize={12}
            fontFamily="poppinsLight"
            onClick={onDelete}
          />
        )}

        <LoadingButtonWrapper
          loading={saveLoading}
          title={mode === 'add' ? 'Save' : 'Update'}
          style={{
            width: saveLoading ? 130 : 70,
            borderRadius: 5,
            letterSpacing: 0.5,
            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
            transition: 'width 0.3s ease'
          }}
          height={30}
          fontSize={12}
          fontFamily="poppinsLight"
          onClick={() =>
            onSave({
              id: initialValue?.id,
              name: title
            })
          }
        />
      </DialogActions>
    </Dialog>
  );
}
